import { useEffect, useState } from "react";
import { apiClient } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const formatDate = (value) => {
  try {
    return new Date(value).toLocaleString();
  } catch {
    return value;
  }
};

export const AdminSubmissionsPage = () => {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchSubmissions = async () => {
      try {
        const response = await apiClient.get("/contact/submissions");
        setSubmissions(response.data);
      } catch (requestError) {
        setError("Unable to load submissions.");
        console.error(requestError);
      } finally {
        setLoading(false);
      }
    };

    fetchSubmissions();
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-6 pb-20 pt-16 md:px-10" data-testid="admin-submissions-page-wrapper">
      <section className="mb-8" data-testid="admin-submissions-page-header">
        <p className="text-sm uppercase tracking-[0.2em] text-[#6FE3C1]" data-testid="admin-submissions-kicker">Admin</p>
        <h1 className="mt-3 text-4xl font-bold md:text-5xl" data-testid="admin-submissions-heading">Contact Form Submissions</h1>
      </section>

      <Card className="border-white/10 bg-[#0B253C]/60 p-4 md:p-6">
        {loading ? <p data-testid="admin-submissions-loading">Loading submissions...</p> : null}
        {error ? <p className="text-red-400" data-testid="admin-submissions-error">{error}</p> : null}
        {!loading && !error ? (
          <Table data-testid="admin-submissions-table">
            <TableHeader>
              <TableRow>
                <TableHead data-testid="admin-submissions-head-name">Name</TableHead>
                <TableHead data-testid="admin-submissions-head-email">Email</TableHead>
                <TableHead data-testid="admin-submissions-head-company">Company</TableHead>
                <TableHead data-testid="admin-submissions-head-hiring-needs">Hiring Needs</TableHead>
                <TableHead data-testid="admin-submissions-head-monthly-volume">Monthly Hiring Volume</TableHead>
                <TableHead data-testid="admin-submissions-head-date">Submitted</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {submissions.map((item, index) => (
                <TableRow key={item.id || index}>
                  <TableCell data-testid={`admin-submissions-row-${index + 1}-name`}>{item.name}</TableCell>
                  <TableCell data-testid={`admin-submissions-row-${index + 1}-email`}>{item.email}</TableCell>
                  <TableCell data-testid={`admin-submissions-row-${index + 1}-company`}>{item.company}</TableCell>
                  <TableCell data-testid={`admin-submissions-row-${index + 1}-hiring-needs`}>
                    {item.hiring_needs || item.message || "—"}
                  </TableCell>
                  <TableCell data-testid={`admin-submissions-row-${index + 1}-monthly-volume`}>
                    {item.monthly_hiring_volume || "—"}
                  </TableCell>
                  <TableCell data-testid={`admin-submissions-row-${index + 1}-date`}>{formatDate(item.created_at)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : null}
      </Card>
    </div>
  );
};
